import _ from 'lodash'
import Vue from 'vue'

export class TooManyRecordsFound extends Error {}
export class NoRecordFound extends Error {}

export class SingleQueryResult {
    constructor() {
        this._key = undefined
        this._value = undefined
    }

    get isEmpty() {
        return this._key === undefined
    }

    get value() {
        return this._value
    }

    set value(v) {
        this._value = v
    }

    get key() {
        return this._key
    }

    set key(k) {
        this._key = k
    }

    get singleValue() {
        return _.get(this.value, 'value.value', undefined)
    }

    set singleValue(value) {
        Vue.set(this.value.value, 'value', value)
    }
}


export default class TaskQuery {
    constructor(store) {
        this.$store = store
    }

    PVQuery(task, { tag = {}, value = null }) {
        return _.filter(task, t => {
            const tagged = _.filter(t.propertyValues, (pv, key) => {
                const pt = this.$store.getters.propertyTypeByKey(key)
                const tags = _.get(pt, 'settings.systags', [])
                const hasTag = _.get(tags, tag, false)
                return hasTag
            })
            return _.size(tagged) > 0
        })
    }

    singleValueByTag(task, tag) {
        const tagged = _.filter(task.propertyValues, (pv, key) => {
            const pt = this.$store.getters.propertyTypeByKey(key)
            const tags = _.get(pt, 'settings.systags', [])
            const hasTag = _.get(tags, tag, false)
            return hasTag
        })
        if (_.size(tagged) === 0) {
            return undefined
        }
        if (_.size(tagged) > 1) {
            throw new Error('Too much tagged values')
        }
        return _.get(tagged, '[0].value.value', undefined)
    }

    onePropertyByTag(task, tag) {
        const result = new SingleQueryResult()
        _.each(task.propertyValues, (pv, key) => {
            const pt = this.$store.getters.propertyTypeByKey(key)
            const tags = _.get(pt, 'settings.systags', [])
            const hasTag = _.get(tags, tag, false)
            if (hasTag) {
                result.key = key
                result.value = pv
            }
        })
        if (result.isEmpty) {
            throw new NoRecordFound()
        } else {
            return result
        }
    }

    propertyValuesByTag(task, tag) {
        const tagged = _.filter(task.propertyValues, (pv, key) => {
            const pt = this.$store.getters.propertyTypeByKey(key)
            const tags = _.get(pt, 'settings.systags', [])
            const hasTag = _.get(tags, tag, false)
            return hasTag
        })
        return tagged
    }

    pickPropertyValuesByTag(task, tag) {
        const tagged = _.pickBy(task.propertyValues, (pv, key) => {
            const pt = this.$store.getters.propertyTypeByKey(key)
            const tags = _.get(pt, 'settings.systags', [])
            const hasTag = _.get(tags, tag, false)
            return hasTag
        })
        return tagged
    }
}
